export default "__VITE_ASSET__CHi0$jUo__"